import { ILocalizationClient } from "@multiweb/clients/localization/ILocalizationClient";
import { ILocalizationItem } from "@multiweb/types/contracts/localizations";
import { HTTPRequest } from "Global/Base/Comunication/HTTPRequest";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";
import { ASServices, getServiceURL } from "OW.Remoting/Basic/ServiceEndpoints";

interface LocalizationItemDTO {
    Lang: string;
    Code: string;
    Text: string;
    Description: string | null;
}

/**
 * @internal
 */
export class LocalizationClient implements ILocalizationClient {
    private readonly _webServiceUrl: string;

    constructor(webServiceUrl: string) {
        this._webServiceUrl = webServiceUrl;
    }

    public async getLocalizations(language: string, locKeys: readonly string[], cancellationToken: CancellationToken = CancellationToken.none): Promise<readonly ILocalizationItem[]> {
        const response = (await HTTPRequest.jsonRequest("POST", `${this._webServiceUrl}/${getServiceURL(ASServices.cultures)}/Localizations?lang=${language}`, cancellationToken, { data: locKeys })) as LocalizationItemDTO[];
        return response.map(dto => ({
            language: dto.Lang,
            locKey: dto.Code,
            primaryText: dto.Text,
            secondaryText: dto.Description === "null" ? undefined : (dto.Description || undefined),
        }));
    }
}
